import { render, staticRenderFns } from "./TeMaFenXi.vue?vue&type=template&id=058f75e2&scoped=true&"
import script from "./TeMaFenXi.vue?vue&type=script&lang=js&"
export * from "./TeMaFenXi.vue?vue&type=script&lang=js&"
import style0 from "./TeMaFenXi.vue?vue&type=style&index=0&id=058f75e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f75e2",
  null
  
)

export default component.exports